import styled from "styled-components";

export const Main = styled.main`
  position: relative;
  min-height: calc(100vh - 164px);
  margin: 0;
  margin-top: 80px;
  text-align: center;
`;
